import type { TeamMembersQuery, RolesQuery, PermissionsQuery } from '@/gql/graphql';

/** A single enriched team-member row (from the `TeamMembers` query). */
export type TeamMember = TeamMembersQuery['teamMembers'][number];

/** A grantable role from the role catalog (from the `Roles` query). */
export type Role = RolesQuery['roles'][number];

/** A grantable permission from the catalog (from the `Permissions` query). */
export type Permission = PermissionsQuery['permissions'][number];

/**
 * Prettify a machine name for display: split on hyphens/underscores and
 * title-case each word. e.g. `agency-admin` → "Agency Admin",
 * `payroll_specialist` → "Payroll Specialist".
 */
export function prettifyName(machine: string): string {
  return machine
    .split(/[-_]/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

/** Best-effort display name for a member row: name → email → raw id. */
export function memberDisplayName(m: Pick<TeamMember, 'displayName' | 'email' | 'platformUserId'>): string {
  return m.displayName ?? m.email ?? m.platformUserId;
}
